<template>
  <div class="info-icon" :class="{ 'info-icon--unsubstantiated': source?.unsubstantiated }">
    <img v-if="showIcon && source?.logo" :src="source.logo" :alt="source.name || 'logo'" class="logo" />

    <div v-if="!showIcon && source?.unsubstantiated" class="unsubstantiated-label">
      <TextBody :i18n-key="'assist.noCitationFound'" weight="medium" tag="span" color="#000" />
      <div class="unsubstantiated-bulet">·</div>
      <span class="unsubstantiated-text">{{ label }}</span>
    </div>
    <span v-else>{{ label }}</span>
  </div>
</template>

<script>
import TextBody from '~/components/common/TextBody';

export default {
  name: 'CitationInfoLabel',
  components: { TextBody },
  props: {
    label: {
      type: Number,
      default: 1,
    },
    source: {
      type: Object,
      default: () => ({}),
    },
    showIcon: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
  height: 16px;
  color: $bb-neutral-1;
  box-sizing: border-box;
  margin-right: $bb-spacing-1;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  text-transform: capitalize;
  padding: $bb-spacing-2;
  border-radius: 24px;
  border: 1px solid #e8e7e5;
  background: #e8e7e5;

  &:hover {
    border: 1px solid $bb-neutral-1;
  }

  &--unsubstantiated {
    border: 1px dashed $bb-neutral-1;
    background-color: transparent;
  }

  .unsubstantiated-text {
    color: $bb-neutral-2;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    max-width: 100px;
  }

  .unsubstantiated-bulet {
    margin: 0 $bb-spacing-1;
    color: $bb-neutral-2;
  }

  .unsubstantiated-label {
    display: flex;
    align-items: center;
    align-items: center;
    min-width: 0;
    white-space: nowrap;
  }
}
</style>
